import {request} from './base'

export default {
    queryPage(params) {
        return request('/bizOrg/queryPage', params, 'get')
    },
    queryBriefList() {
        return request('/bizOrg/queryBriefList', null, 'get')
    },
    getMiniCode(params) {
        return request('/bizOrg/getMiniCode', params, 'get')
    },
    getQrCode(params) {
        return request('/bizOrg/getQrCode', params, 'get')
    },
    queryPriceConfigById(param) {
        return request('/bizOrg/queryPriceConfigById', param, 'get')
    }
}
